package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.allergens_tab.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.checked_ingredients_list.CheckedIngredient
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.ingeredient_list.Ingredients
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomIcon
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.jetbrains.compose.web.css.px

@Composable
fun AddingCustomAllergene(
    modifier: Modifier=Modifier,
    title:String="",
    windowSizeMode: WindowSizeModeEnum,
    checkedIngredients: List<CheckedIngredient?>?,
    ingredients: List<Ingredients>?,
    showCustomAllergeneDialog: () -> Unit,
    onCancelClick: () -> Unit,
    updateAllergenData: (Boolean, String) -> Unit,
)
{
    val selectedAllergene= remember { mutableStateOf<Ingredients?>(null) }

    val clickableStatus = checkedIngredients?.map { it?.id }
        ?.contains(selectedAllergene.value?.id) != true && selectedAllergene.value!=null


    Column(
        modifier = modifier
            .width(Dimen.largeEditTextWidth2)
            .margin(
                left = if (windowSizeMode==WindowSizeModeEnum.Desktop)
                    Dimen.extraLargePadding else 0.px,
                top = Dimen.normalPadding
            )
    )
    {
        if (title.isNotEmpty()){
            SpanText(
                text =title,
                modifier = Modifier
                    .margin(
                        bottom = Dimen.largePadding,
                        top = Dimen.smallPadding,
                    )
                    .fontSize(FontSizes.mediumFontSize)
                    .fontFamily(FontFamily.Jakarta)
                    .fontWeight(FontWeight.SemiBold)
                    .color(Theme.TextSecondary.rgb)
            )
        }


        val nutritionalValues= listOf(
            Strings.current().nutritionalValues
        )

        DropDownItem(
            modifier = Modifier
                .margin(bottom = Dimen.highLargePadding),
            label = Strings.current().group ,
            itemWidth = Dimen.largeEditTextWidth2,
            options =nutritionalValues,
            disable = true,
            selectedItem =nutritionalValues.get(0),
            displayText ={
                if (it is String)
                    it
                else ""
            },
            onOptionClick ={

            },
        )

        Row(
            modifier = Modifier
                .margin(bottom = Dimen.extraLargePadding)
                .fillMaxWidth(),
            verticalAlignment = Alignment.Bottom,
        ){
            DropDownItem(
                modifier = Modifier,
                label = Strings.current().name ,
                itemWidth = Dimen.semiLargeEditTextWidth,
                options =ingredients?:listOf(),
                selectedItem =selectedAllergene.value,
                displayText = {
                      if (it is Ingredients)
                          it.name?:""
                      else ""
                },
                onOptionClick ={
                    if (it is Ingredients){
                        selectedAllergene.value=it
                    }
                },
            )

            Spacer()

            CustomIcon(
                modifier = Modifier,
                icon = Res.PathIcon.add,
                onIconClick = {
                    showCustomAllergeneDialog()
                },
                tooltipText = Strings.current().add,
            )

        }

        CheckboxComponent(
            modifier = Modifier
                .margin(bottom = Dimen.extraLargePadding),
            checkStatus = true,
            enabled = false,
            title = Strings.current().takeOver,
            onUnChecked = {

            },
            onChecked = {

            }
        )

        Row(
            modifier = Modifier
                .fillMaxWidth()
        )
        {
            CustomButton(
                title = Strings.current().cancel,
                isClickable = true,
                width = Dimen.semiLargeSubmitButtonWidth,
                buttonType = ButtonTypes.TEXT,
                onButtonClick = {
                    onCancelClick()
                }
            )

            Spacer()

            CustomButton(
                title = Strings.current().save,
                width = Dimen.semiLargeSubmitButtonWidth,
                isClickable =clickableStatus
                ,
                buttonType = ButtonTypes.CONTAINED,
                onButtonClick = {
                    updateAllergenData(
                        true,selectedAllergene.value?.id?:""
                    )
                }
            )


        }




    }


}